import { render, staticRenderFns } from "./segmentQueryStudio.vue?vue&type=template&id=043bbdb4&"
import script from "./segmentQueryStudio.vue?vue&type=script&lang=js&"
export * from "./segmentQueryStudio.vue?vue&type=script&lang=js&"
import style0 from "./segmentQueryStudio.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports